export default function ProductHero() {
  return (
    <section className="pd-hero">
      <div className="hfx" aria-hidden="true">
        <i className="bl b1" />
        <i className="bl b2" />
        <i className="bl b3" />
        <i className="dg" />
        <i className="sp" style={{ left: "18%", top: "22%" }} />
        <i className="sp" style={{ left: "80%", top: "16%", animationDelay: "-1.5s" }} />
        <i className="sp" style={{ left: "70%", top: "44%", animationDelay: "-3s" }} />
        <i className="sp" style={{ left: "12%", top: "58%", animationDelay: "-2.2s" }} />
      </div>
      <div className="wrap">
        <div className="eb pd-rv">PRODUCT</div>
        <h1 className="pd-rv d1">
          필요한 기능을 연결해
          <br />
          <em>AI Agent</em>
          를 만들고 운영하세요
        </h1>
        <p className="ds pd-rv d1">
          코딩 없이 필요한 기능을 연결해 업무에 맞는 AI Agent를 만들어보세요.
          <br />
          사내 지식 연결부터 배포·운영까지 한곳에서 관리할 수 있습니다.
        </p>
        <div className="pd-chips pd-rv d2">
          <div className="c">
            <span className="ci" style={{ background: "var(--grn)" }}>
              <svg className="i">
                <use href="#msg" />
              </svg>
            </span>
            <div>
              <small>TRIGGER</small>
              <b>채팅 시작</b>
            </div>
          </div>
          <svg className="i">
            <use href="#arr" />
          </svg>
          <div className="c">
            <span className="ci" style={{ background: "var(--blu)" }}>
              <svg className="i">
                <use href="#doc" />
              </svg>
            </span>
            <div>
              <small>NODE</small>
              <b>문서 검색</b>
            </div>
          </div>
          <svg className="i">
            <use href="#arr" />
          </svg>
          <div className="c">
            <span className="ci" style={{ background: "var(--pnk)" }}>
              <svg className="i">
                <use href="#spark" />
              </svg>
            </span>
            <div>
              <small>NODE</small>
              <b>AI 응답</b>
            </div>
          </div>
          <svg className="i">
            <use href="#arr" />
          </svg>
          <div className="c">
            <span className="ci" style={{ background: "var(--ac)" }}>
              <svg className="i">
                <use href="#mail" />
              </svg>
            </span>
            <div>
              <small>NODE</small>
              <b>이메일 커넥터</b>
            </div>
          </div>
        </div>
        <div className="pd-demo pd-rv d2">
          <div className="pd-pal">
            <h4>설치된 도구</h4>
            <p>필요한 기능(노드)을 골라 업무 흐름에 추가합니다.</p>
            <small>
              트리거
              <span>2</span>
            </small>
            <div className="gr">
              <div className="pd-it" data-k="sch">
                <span className="pd-ic l" style={{ color: "var(--org)" }}>
                  <svg className="i">
                    <use href="#clock" />
                  </svg>
                </span>
                스케줄
              </div>
              <div className="pd-it" data-k="chat">
                <span className="pd-ic l" style={{ color: "var(--grn)" }}>
                  <svg className="i">
                    <use href="#msg" />
                  </svg>
                </span>
                채팅 시작
              </div>
            </div>
            <small>
              액션
              <span>3</span>
            </small>
            <div className="gr">
              <div className="pd-it" data-k="ai">
                <span className="pd-ic l" style={{ color: "var(--pnk)" }}>
                  <svg className="i">
                    <use href="#spark" />
                  </svg>
                </span>
                AI 응답
              </div>
              <div className="pd-it" data-k="doc">
                <span className="pd-ic l" style={{ color: "var(--blu)" }}>
                  <svg className="i">
                    <use href="#doc" />
                  </svg>
                </span>
                문서 검색
              </div>
              <div className="pd-it" data-k="judge">
                <span className="pd-ic l" style={{ color: "#F97316" }}>
                  <svg className="i">
                    <use href="#branch" />
                  </svg>
                </span>
                판단
              </div>
            </div>
            <small>
              커넥터
              <span>6</span>
            </small>
            <div className="gr">
              <div className="pd-it" data-k="web">
                <span className="pd-ic l" style={{ color: "#2563EB" }}>
                  <svg className="i">
                    <use href="#globe" />
                  </svg>
                </span>
                웹 검색
              </div>
              <div className="pd-it" data-k="gd">
                <span className="pd-ic l">
                  <img src="/site/logos/google-drive.svg" alt="" />
                </span>
                Google Drive
              </div>
              <div className="pd-it" data-k="mail">
                <span className="pd-ic l" style={{ color: "var(--ac)" }}>
                  <svg className="i">
                    <use href="#mail" />
                  </svg>
                </span>
                이메일 커넥터
              </div>
              <div className="pd-it" data-k="slack">
                <span className="pd-ic l">
                  <img src="/site/logos/slack.svg" alt="" />
                </span>
                Slack
              </div>
              <div className="pd-it" data-k="notion">
                <span className="pd-ic l">
                  <img src="/site/logos/notion.svg" alt="" />
                </span>
                Notion
              </div>
              <div className="pd-it" data-k="mcp">
                <span className="pd-ic l" style={{ color: "#191F28" }}>
                  <svg className="i">
                    <use href="#plug" />
                  </svg>
                </span>
                MCP 서버
              </div>
            </div>
          </div>
          <div className="pd-cv">
            <div className="pd-tb">
              <span className="dots">
                <i />
                <i />
                <i />
              </span>
              AcXion-On · 워크플로우 빌더
              <span className="st">
                <i />
                <b>편집 중</b>
              </span>
              <span className="sp" />
              <button className="gh" data-reset="">
                <svg className="i">
                  <use href="#replay" />
                </svg>
                초기화
              </button>
              <button className="gh" data-save="">
                <svg className="i">
                  <use href="#save" />
                </svg>
                저장
              </button>
              <button className="pr" data-run="">
                <svg className="i">
                  <use href="#play" />
                </svg>
                실행
              </button>
            </div>
            <div className="pd-stg">
              <span className="lb">워크플로우</span>
              <svg className="wr" />
              <div className="hint">
                <svg className="i">
                  <use href="#hand" />
                </svg>
                왼쪽 기능을 끌어다 놓고, 노드 오른쪽 점을 끌어 연결해보세요
              </div>
            </div>
            <div className="pd-toast">
              <i>
                <svg className="i">
                  <use href="#check" />
                </svg>
              </i>
              <b>워크플로우 실행 완료</b>
            </div>
          </div>
          <div className="pd-set" />
          <div className="pd-demo-cur">
            <div className="nd2">
              <span className="pd-ic" style={{ background: "var(--pnk)", width: "32px", height: "32px", borderRadius: "10px" }}>
                <svg className="i" style={{ width: "16px", height: "16px" }}>
                  <use href="#spark" />
                </svg>
              </span>
              <span>
                AI 응답 (LLM)
                <small>모델 · 프롬프트 설정</small>
              </span>
            </div>
            <svg viewBox="0 0 22 22">
              <use href="#ptr" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
